import React from 'react';

import { useBreakpointValue } from 'native-base';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';
import { NAV_HEIGHT } from 'styles/constants/enums';

const DESKTOP_NAV_HEIGHT = 78;

export const ProductSkeletonHeader = ({ style, ...props }: BoxProps) => {
  const height = useBreakpointValue({
    base: NAV_HEIGHT.MOBILE,
    md: DESKTOP_NAV_HEIGHT,
  });

  return React.createElement(Box, {
    ...props,
    style: [styles.productSkeletonHeader, { height }, style],
  });
};

export const ProductSkeletonCta = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.productSkeletonCta, style],
  });

export const ProductSkeletonButton = ({ style, ...props }: BoxProps) => {
  const width = useBreakpointValue({
    base: '100%',
    md: '20%',
  });

  return React.createElement(Box, {
    ...props,
    style: [styles.productSkeletonButton, { width }, style],
  });
};

export const ProductOverviewSkeletonContainer = ({ style, ...props }: BoxProps) => {
  const height = useBreakpointValue({
    base: 400,
    md: 200,
  });

  return React.createElement(Box, {
    ...props,
    style: [{ height }, style],
  });
};

export const ProductInfoSkeletonContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.productInfoSkeletonContainer, style],
  });

export const ProductContentSkeleton = ({ style, ...props }: BoxProps) => {
  const marginTop = useBreakpointValue({
    base: spacing.$0,
    md: spacing.$16,
  });
  const paddingHorizontal = useBreakpointValue({
    base: spacing.$0,
    md: spacing.$64,
  });

  return React.createElement(Box, {
    ...props,
    style: [styles.productContentSkeleton, { marginTop, paddingHorizontal }, style],
  });
};

export const CloseBtnWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.closeBtnWrapper, style],
  });

const styles = StyleSheet.create({
  closeBtnWrapper: {
    position: 'absolute',
    right: spacing.$4,
  },
  productContentSkeleton: {
    width: '100%',
  },
  productInfoSkeletonContainer: {
    backgroundColor: primitive.$blackOpacity4,
    flex: 1,
    paddingHorizontal: spacing.$2,
    paddingVertical: spacing.$4,
  },
  productSkeletonButton: {
    alignItems: 'center',
    borderColor: getDesignToken('color-tertiary'),
    borderRadius: 999,
    borderWidth: 1,
    height: 45,
    justifyContent: 'center',
    paddingHorizontal: spacing.$24,
  },
  productSkeletonCta: {
    alignItems: 'center',
    borderTopColor: primitive.$blackOpacity4,
    borderTopWidth: 2,
    height: 90,
    justifyContent: 'center',
    paddingHorizontal: spacing.$4,
    width: '100%',
  },
  productSkeletonHeader: {
    alignItems: 'center',
    backgroundColor: primitive.$blackOpacity4,
    justifyContent: 'center',
    paddingHorizontal: spacing.$24,
    width: '100%',
  },
});
